import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ReactNode } from "react";

const exportExcelTemplate = (headers: (string | ReactNode)[], data?: (string | ReactNode)[][] | null, callbackError?: (e: Error) => any, filename: string = 'template') => {
    try {
        let worksheetData = [headers]; 
        if(data) {
            worksheetData = [...worksheetData, ...data]
        }
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Лист1");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `${filename}.xlsx`);
    } catch (error) {
       if(callbackError) callbackError(error)
    }
  
  
};

export {
    exportExcelTemplate
}